module.exports = __webpack_public_path__ + "media/images/article/2021_08-c204f80e0ff5c43758884f12a0c66994.png";